export const assessmentData = [
  {
    id: 1,
    title: "Foundational Clinical Knowledge",
    items: [
      {
        id: "1.1",
        title: "Theories & Models of Human Functioning",
        description: "Understanding human development, psychological functioning, trauma, and contextual factors influencing clients."
      },
      {
        id: "1.2",
        title: "Therapeutic Framework & Theory-Driven Practice",
        description: "Applying your primary theoretical model(s); knowing when therapy is indicated/contraindicated; understanding mechanisms of change."
      },
      {
        id: "1.3",
        title: "Psychopathology, Diagnosis & Comparative Approaches",
        description: "Understanding presenting concerns, major diagnostic categories, risk factors, and the range of psychotherapies practiced in Ontario."
      },
      {
        id: "1.4",
        title: "Use of Self & Self-Awareness",
        description: "Awareness of personal values, biases, reactions, power dynamics, and how your \"self\" affects therapy."
      },
      {
        id: "1.5",
        title: "Diversity, Equity & Cultural Responsiveness",
        description: "Applying anti-oppressive, culturally safe, and socially informed practice; adapting therapy and supporting client access/barriers."
      }
    ]
  },
  {
    id: 2,
    title: "Professional Communication & Relationships",
    items: [
      {
        id: "2.1",
        title: "Professional Communication",
        description: "Written, verbal, and electronic communication that is clear, concise, appropriate to the audience, and ethically aligned."
      },
      {
        id: "2.2",
        title: "Professionalism & Boundaries",
        description: "Respect, integrity, conflict management, ethical conduct, maintaining therapeutic and collegial boundaries."
      },
      {
        id: "2.3",
        title: "Collaboration & Interprofessional Practice",
        description: "Working effectively with colleagues, diverse professionals, and care teams; referring appropriately."
      }
    ]
  },
  {
    id: 3,
    title: "Ethics, Legal Standards & Professional Responsibilities",
    items: [
      {
        id: "3.1",
        title: "Legal, Regulatory & Organizational Compliance",
        description: "Following CRPO/OCSWSSW standards, privacy law (PHIPA), organizational policies, documentation requirements."
      },
      {
        id: "3.2",
        title: "Ethical Decision-Making",
        description: "Identifying ethical issues, applying ethical frameworks, accepting responsibility for decisions."
      },
      {
        id: "3.3",
        title: "Practitioner Wellness & Fitness to Practice",
        description: "Self-care, emotional regulation, hygiene/professional appearance, support systems, managing impairment risks."
      },
      {
        id: "3.4",
        title: "Reflective Practice, Feedback & Ongoing Improvement",
        description: "Seeking and integrating feedback, assessing effectiveness, using client outcome measures, planning improvement goals."
      },
      {
        id: "3.5",
        title: "Supervision & Consultation",
        description: "Knowing when to initiate supervision/consultation (clinical, legal, ethical), preparing for sessions, protecting privacy."
      },
      {
        id: "3.6",
        title: "Record-Keeping & Reporting",
        description: "Accurate, timely notes; third-party reports; understanding legal/ethical implications."
      },
      {
        id: "3.7",
        title: "Advocacy & Navigating Systems",
        description: "Identifying when clients need advocacy/support and helping them engage with systems or community resources."
      }
    ]
  },
  {
    id: 4,
    title: "Direct Clinical Work",
    items: [
      {
        id: "4.1",
        title: "Orientation, Informed Consent & Client Rights",
        description: "Clear explanation of services, privacy limits, roles, risks/benefits, and obtaining informed consent."
      },
      {
        id: "4.2",
        title: "Core Conditions & Therapeutic Alliance",
        description: "Empathy, attunement, boundaries, safety, dependability, theoretical concepts explained accessibly."
      },
      {
        id: "4.3",
        title: "Safe & Effective Use of Self",
        description: "Self-disclosure, recognizing personal issues, managing power dynamics, congruent communication."
      },
      {
        id: "4.4",
        title: "Risk Assessment & Safety Planning",
        description: "Suicide risk assessment, mandatory reporting, developing plans, referral, documentation, monitoring risk over time."
      },
      {
        id: "4.5",
        title: "Assessment, Treatment Planning & Intervention Skills",
        description: "Assessment formulation, goals, treatment direction, emotional work, pacing, using a variety of strategies, reviewing progress, adjusting treatment, identifying when to end."
      },
      {
        id: "4.6",
        title: "Referral & Care Coordination",
        description: "Knowing when/how to refer, maintaining networks, collaborative transitions."
      },
      {
        id: "4.7",
        title: "Ending & Closure",
        description: "Preparing clients, reviewing progress, planning next steps, follow-up options."
      }
    ]
  },
  {
    id: 5,
    title: "Professional Knowledge, Research & Development",
    items: [
      {
        id: "5.1",
        title: "Staying Current with Professional Literature",
        description: "Reading current literature; applying knowledge to practice; remaining updated in foundational areas."
      },
      {
        id: "5.2",
        title: "Integrating Research into Practice",
        description: "Understanding research methods, critically analyzing findings, applying research to clinical decisions."
      }
    ]
  }
];